'use strict';
const handleOptionBtnClick = e => {
    e.stopPropagation();
    const { currentTarget } = e;
    const { value } = currentTarget;
    const spinner = $.spinner();

    // ajax code is taken from SFRA search/search.js in sort
    spinner.start();
    $(this).trigger('search:sort', value);
    $.ajax({
        url: value,
        data: {
            selectedUrl: value
        },
        method: 'GET',
        success: function (response) {
            $('body').trigger('search:sortOptions', { response: response });
            spinner.stop();
        },
        error: function () {
            spinner.stop();
        }
    });
};

module.exports = () => {
    $('.sort-order-dropdown, .sort-order-menu').on('click', '.sort-order-menu-option', handleOptionBtnClick);
};
